import { toast as originalToast } from 'sonner'

import {
  apply2faGuardErrorResolver,
  parse2faGuardStagedContentResolver
} from '$services/api/resolvers'

// @ts-expect-error IDK man
const promise: typeof originalToast.promise = (job, options) => {
  const duration = options?.duration

  const id = originalToast.loading(options?.loading, {
    id: options?.id,
    duration
  })

  const handledPromise = async () => {
    try {
      const result = await (typeof job === 'function' ? job() : job)

      const resolvedData = (() => {
        if (typeof options?.success == 'function') {
          return options?.success?.(result)
        }

        return options?.success
      })()

      const isEmpty = !!resolvedData == false

      // @ts-expect-error IDK man
      const is2FAContent = !!parse2faGuardStagedContentResolver(result?.data)

      if (is2FAContent || isEmpty) {
        originalToast.dismiss(id)
      } else {
        // @ts-expect-error IDK man
        originalToast.success(resolvedData, { id, duration })
      }

      return ['success', result]
    } catch (err) {
      const is2FAError =
        apply2faGuardErrorResolver(err)?.data?.status === '2fa_required'

      const resolvedData = (() => {
        if (typeof options?.error == 'function') {
          return options?.error?.(err)
        }

        return options?.error
      })()

      const isEmpty = !!resolvedData == false

      if (is2FAError || isEmpty) {
        originalToast.dismiss(id)
      } else {
        // @ts-expect-error IDK man
        originalToast.error(resolvedData, { id, duration })
      }

      return ['error', err]
    }
  }

  const task = handledPromise()

  const unwrap = async () => {
    const [status, result] = await task

    if (status === 'success') {
      return result
    }

    throw result
  }

  return { unwrap }
}

export const toast = {
  ...originalToast,
  promise
}
